export default {
  name: "protocol",
  props: ["url"],
  setup(props, ctx) {
    return {
      props
    };
  }
};